import React, { useState, useEffect } from 'react';
import { useLanguage } from './../../store/languageContext';
import { LanguageFactory } from './../../factories';
import { Tabs } from 'antd';
import GuestRoomsListTab from './GuestRoomsList';
import RoomAmenities from './RoomAmenities';
import GuestRoomsComponents from './components';
import { Tooltip } from 'antd';


// GuestRooms
const { TabPane } = Tabs;
interface propsTypes {
    isEditable?: void | any,
    cancelEditable?: void | any,
}

const GuestRooms = (props: propsTypes) => {
    
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const [currentRow, setCurrentRow] = useState<object>();
    const [operationFlag, setOperationFlag] = useState('table')
    const [defaultTabKey, setDefaultTabKey] = useState<string>('1')
    const [defKey, setDefKey] = useState<string>('1')
    const [singleAmenity, setSingleAmenity] = useState<string>('')
    const [disableRoomAmenity, setDisableRoomAmenity] = useState<boolean>(true);

    const onChange = (key: string) => {
        setDefKey(key);
      };

    const setOperation = (value: string)=>{
        setOperationFlag(value)
        if (value === 'table'){
            setCurrentRow({})
        }
    }

    useEffect(() => {
        if (
        operationFlag === 'view' ||
        operationFlag === 'add' ||
        operationFlag === 'edit'
        ) {
            setDefaultTabKey('1')
        } else {
            setDefaultTabKey('2')
        }
    },[operationFlag])

    return (
        <>
                {operationFlag === 'table' && 
                <Tabs defaultActiveKey={defaultTabKey} onChange={onChange}>
                    <TabPane
                        tab={lang.translate(language, 'guestroom_list_tab')}
                        key="1">
                        <GuestRoomsListTab 
                            setCurrentRow={setCurrentRow}  
                            currentRow={currentRow} 
                            setOperation={setOperation}  
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable} 
                            setDefKey={setDefKey}
                            setSingleAmenity={setSingleAmenity}
                            defKey={defKey}
                            setDisableRoomAmenity={setDisableRoomAmenity}
                        />
                    </TabPane>
                    <TabPane
                        tab={disableRoomAmenity ? (
                            <Tooltip title="At least one guest room should be completed before you can create any amenities.">
                                        <span>Room Amenities</span>
                            </Tooltip>
                            ): 'Room Amenities'}
                        key='2'
                        disabled = {disableRoomAmenity}> 
                            <RoomAmenities
                            setCurrentRow={setCurrentRow}  
                            currentRow={currentRow} 
                            setOperation={setOperation}  
                            isEditable={props.isEditable} 
                            cancelEditable={props.cancelEditable}
                            setDefKey={setDefKey} 
                            setSingleAmenity={setSingleAmenity}
                            />    
                    </TabPane>
                   
                </Tabs>}
                {
                    (operationFlag === 'add' 
                        || operationFlag === 'edit' 
                        || operationFlag === 'view'
                    ) && 
                    <GuestRoomsComponents
                        setOperation={setOperation} 
                        operationFlag={operationFlag}
                        setCurrentRow={setCurrentRow}  
                        currentRow={currentRow}  
                        isEditable={props.isEditable} 
                        cancelEditable={props.cancelEditable}
                        defKey={defKey}
                        setDefKey={setDefKey}
                        singleAmenity={singleAmenity}
                    />
                }
     </>
    )
}
export default GuestRooms;

